<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title {{ operatorPageData.title }}
      .profile-page__description {{ operatorPageData.description }}
    .profile-page__body
      .operator-table
        .operator-table__table
          table-component(
            :thead-data="tableHead"
            :tbody-data="shiftsData"
          )
        //- .operator-table__pagination
        //-   pagination
</template>

<script>
import {mapActions} from "vuex";

import TableComponent from "@/components/table/Table";
import Pagination from "../components/Pagination";

export default {
  name: "OperatorShifts",
  components: {
    Pagination,
    TableComponent
  },
  data() {
    return {
      operatorPageData: {
        title: "Смены",
        description: ""
        // "Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а так же загрузить все необходимы для подачи заявки документы и информацию о детях"
      },
      tableHead: [
        {
          enableSorting: true,
          type: "link",
          url: "camp_url",
          text: "Лагерь",
          key: "camp_name"
        },
        {
          enableSorting: true,
          type: "link",
          url: "shift_url",
          text: "Смены",
          key: "name",
          cut: true
        },
        {
          type: "text",
          text: "Начало смены",
          key: "date_start"
        },
        {
          type: "text",
          text: "Длительность",
          key: "duration"
        },
        {
          type: "text",
          text: "Количество мест",
          key: "quotas"
        },
        {
          type: "text",
          text: "Количество свободных\u00A0мест",
          key: "free_quotas"
        }
      ],
      shiftsData: []
    };
  },
  methods: {
    ...mapActions(["getShifts"])
  },
  mounted() {
    this.getShifts().then(shiftsData => {
      this.shiftsData = shiftsData.map(shift => {
        shift.camp_url = `/pages/camps/${shift.camp.id}`;
        shift.shift_url = `/pages/shifts/${shift.id}`;
        shift.camp_name = shift.camp.name;
        shift.duration_time = "duration_time";
        shift.duration = `${shift.duration} дней`;
        shift.date_start = new Date(shift.date_started).toLocaleDateString(
          "ru"
        );
        return shift;
      });
    });
  }
};
</script>
